import checkIcon from "../../../assets/icons/check-circle.png";
import timesIcon from "../../../assets/icons/times-circle.png";

import DefaultImage from "../Image/DefaultImage";
import Image from "../Image/Image";

import styles from "./Card.module.css";

function Card({ image, imageStyles, description = "Description", disabled }) {
	const cardStyles = disabled
		? [styles.card, styles.disabled].join(" ")
		: styles.card;

	return (
        <div className={styles.cardContainer}>
            <div className={cardStyles}>
                {!image && <DefaultImage />}
                {image && (
                    <Image
                        src={image}
                        customStyle={imageStyles}
                        alt={description}
                    />
                )}
            </div>
        </div>
	);
}

export default Card;
